import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink, TabContent, TabPane, Popover, PopoverHeader, PopoverBody } from 'reactstrap';

import ModalMap from './ModalMap';
import ModalRichTextEditor from './ModalRichTextEditor';
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaGoogleMap from '../../components/ParadigmaGoogleMap/ParadigmaGoogleMap';
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaTableModal from "../../components/ParadigmaTableModal/ParadigmaTableModal.js"
import TableArchivos from './TableArchivos';
import TableLotes from './TableLotes';
import UploadImages from './UploadImages';
import api from "../../api";
import { Monedas } from '../Monedas/Monedas/constants.js'
import { getMonedas } from "../../api/apicalls.js";

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: '',
            nomenclatura: '',
            monedas: [], // Todas las Monedas de la api
            monedaPreferida: null,
            direccion: '',
            numero: '',
            piso: '',
            ciudad: null,
            descripcionDireccion: '',
            latitud: 0,
            longitud: 0,
            descripcion: '',
            tiposDeUnidades: [],
            plantillas: [],
            documentos: [],
            planos: [],
            tipo_id: null,
            mostrarEnWeb: false,
            destacado: false,
            anticipo: null,
            cuotas: null,
            descripcionWeb: '',
            imagenes: [],
            postVariables: [
                'nombre',
                'nomenclatura',
                'latitud',
                'longitud',
                'descripcion',
                'tipo_id',
                'mostrarEnWeb',
                'destacado',
                'anticipo',
                'cuotas',
                'descripcionWeb',
            ],
            activeTab: 1,
            errors: {},
            popoverOpen: false,
            monedaPopoverOpen: false,
        };
    }

    configuraciones = {};

    componentWillMount() {
        if (this.props.action === 'CREATE') {
            try {
                this.configuraciones = JSON.parse(localStorage.configuraciones);
                if (this.configuraciones) {
                    this.setState({
                        ciudad: this.configuraciones.localidad.id,
                    });
                }
            } catch(err) {
                // Sin configuracion
            }
        }
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE', 'LOTES']).isRequired,
    }

    async componentDidMount() {
        const monedas = await getMonedas();
        const monedaPesos = monedas
            ? monedas.find(moneda => moneda.id === Monedas.PESOS)
            : null;

        this.setState({ 
            monedas,
            monedaPreferida: monedaPesos,
        });
    }

    findMoneda = (monedaId) => {
        const { monedas } = this.state

        const moneda = monedas
            ? monedas.find(moneda => moneda.id === monedaId)
            : null;

        return moneda
    }

    resetForm() {
        const ciudad = (this.configuraciones && this.configuraciones.localidad) ? this.configuraciones.localidad.id : null;
        const monedaPesos = this.findMoneda(Monedas.PESOS);

        this.setState({
            nombre: '',
            nomenclatura: '',
            monedaPreferida: monedaPesos,
            direccion: '',
            numero: '',
            piso: '',
            ciudad,
            provincia_id : null,
            descripcionDireccion: '',
            latitud: 0,
            longitud: 0,
            descripcion: '',
            tiposDeUnidades: [],
            plantillas: [],
            documentos: [],
            imagenes: [],
            planos: [],
            tipo_id: null,
            mostrarEnWeb: false,
            destacado: false,
            anticipo: null,
            cuotas: null,
            descripcionWeb: '',
            activeTab: 1,
            errors: {},
        });
    }

    getData() {
        const { 
            postVariables,
            monedaPreferida,
        } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        data.moneda_preferida_id = monedaPreferida ? monedaPreferida.id : undefined;

        data.direccion = {
            direccion: this.state.direccion,
            numero: parseInt(this.state.numero) || null,
            piso: this.state.piso,
            localidad_id: this.state.ciudad,
            descripcion: this.state.descripcionDireccion
        }

        data.tiposDeUnidades = this.state.tiposDeUnidades.map(tdu => {
            let tipoDeUnidad = {
                descripcion: tdu.descripcion,
                superficie: tdu.superficie,
                cantidad: tdu.cantidad,
                frente: tdu.frente,
                contrafrente: tdu.contrafrente,
                lado1: tdu.lado1,
                lado2: tdu.lado2,
                lado3: (tdu.lado3 != '') ? (tdu.lado3) : (0),
                lado4: (tdu.lado4 != '') ? (tdu.lado4) : (0),
                lado5: (tdu.lado5 != '') ? (tdu.lado5) : (0),
                lado6: (tdu.lado6 != '') ? (tdu.lado6) : (0),
            };
            if (tdu.id) tipoDeUnidad.id = tdu.id;
            return tipoDeUnidad;
        });

        data.plantillas = this.state.plantillas.map(p => p.id ? { id: p.id } : { archivo: p.archivo });
        data.documentos = this.state.documentos.map(p => p.id ? { id: p.id } : { archivo: p.archivo });
        data.planos = this.state.planos.map(p => p.id ? { id: p.id } : { archivo: p.archivo });
        data.imagenes = this.state.imagenes.map(p => p.id ? { id: p.id } : { imagen: p.imagen });

        if (this.state.direccionId) data.direccion.id = this.state.direccionId;

        return data;
    }

    setData(data) {
        try {
            if (data.success) {
            this.setState({
                nombre: data.nombre,
                nomenclatura: data.nomenclatura,
                monedaPreferida: data.moneda_preferida,
                direccion: data.direccion.direccion,
                numero: data.direccion.numero,
                piso: data.direccion.piso,
                ciudad: data.direccion.localidad.id,
                provincia_id: data.direccion.localidad.provincia.id,
                descripcionDireccion: data.direccion.descripcion,
                direccionId: data.direccion.id,
                latitud: data.latitud,
                longitud: data.longitud,
                descripcion: data.descripcion,
                tiposDeUnidades: data.tiposDeUnidades,
                plantillas: data.plantillas || [],
                documentos: data.documentos || [],
                planos: data.planos || [],
                tipo_id: data.tipo ? data.tipo.id : null,
                mostrarEnWeb: data.mostrarEnWeb,
                destacado: data.destacado,
                anticipo: data.anticipo,
                cuotas: data.cuotas,
                descripcionWeb: data.descripcionWeb,
                imagenes: data.imagenes || []
             });
            }
        } catch (error) {
            console.log(error)
        }
    }

    setErrors(errors) {
        this.setState({ errors });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Loteo",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Loteo ha sido creado con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Loteos",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Loteo ha sido editado con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                title: `Loteo ${this.state.nombre}`,
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Loteos",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Loteo ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: 'Eliminar',
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "LOTES") {
            return {
                get: true,
                title: `Loteo ${this.state.nombre}`,
                buttonTitle: "Lotes",
                danger: false,
                buttonIcon: "fa fa-th fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "btn-warning",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    onPositionChange= (latitud, longitud) => {
        this.setState(prevState => ({
            latitud,
            longitud,
            errors: {
                ...prevState.errors,
                latitud: undefined,
                longitud: undefined
            }
        }));
    }

    onModalOpen = () => {
        const { activeTab, action } = this.props;

        // Setea tab inicial si está definida en el botón
        if (activeTab) {
            this.setState({ activeTab });
        }

        // Setea configuraciones iniciales al abrir el modal
        if (action === 'CREATE') {
            try {
                const config = localStorage.configuraciones ? JSON.parse(localStorage.configuraciones) : null;
                if (config && config.provincia_id && config.localidad_id) {
                    this.setState({
                        provincia_id: config.provincia_id,
                        ciudad: config.localidad_id,
                    });
                }
            } catch(e) {
                console.error(e);
            }
        }

    }

    togglePopover = () => this.setState(prevState => ({ popoverOpen: !prevState.popoverOpen }));

    toggleMonedaPopover = () => this.setState(prevState => ({ monedaPopoverOpen: !prevState.monedaPopoverOpen }));

    onMonedaPreferidaChange = (monedaPreferida) => {
        this.onChangeField('monedaPreferida', monedaPreferida)
    }

    onMonedaDolaresChange = (checked) => {
        const moneda = this.findMoneda(checked ? Monedas.DOLARES : Monedas.PESOS);
        this.onChangeField('monedaPreferida', moneda || { id: checked ? Monedas.DOLARES : Monedas.PESOS });
    }

    render() {
        let vars = this.modalVars();
        const { action } = this.props;
        const {
            provincia_id,
            errors,
            monedaPreferida,
        } = this.state;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        const enDolares = monedaPreferida ? monedaPreferida.id === Monedas.DOLARES : false;

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.loteos.loteos : null)}
                submitUrl={(vars.submitType ? api.loteos.loteos : null)}
                submitType={vars.submitType}
                id={vars.id}

                // onOpen={() => this.props.activeTab && this.setState({ activeTab: this.props.activeTab })}
                onOpen={this.onModalOpen}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}

                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveButtonLabel={vars.saveButtonLabel}
                closeButton={true}

                className="ui-paradigma-modal ui-loteo-modal ui-modal-with-tabs"
                fileUploader
            >

                <Nav tabs className="ui-modal-tabs">
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 1 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 1 }) }}
                        >General</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 2 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 2 }) }}
                        >Tipos de Unidades</NavLink>
                    </NavItem>
                    {
                        ['DELETE', 'DETAIL', 'LOTES'].includes(action) &&
                        <NavItem>
                            <NavLink
                                className={(this.state.activeTab == 3 ? "active" : "")}
                                onClick={() => { this.setState({ activeTab: 3 }) }}
                            >Lotes</NavLink>
                        </NavItem>
                    }
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 4 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 4 }) }}
                        >Archivos</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(this.state.activeTab == 5 ? "active" : "")}
                            onClick={() => { this.setState({ activeTab: 5 }) }}
                        >Web</NavLink>
                    </NavItem>
                </Nav>

                <TabContent
                    activeTab={this.state.activeTab}
                    className="ui-modal-tab-content">
                    <TabPane tabId={1}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Datos principales</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    disabled={vars.disabled}
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Nombre"}
                                    maxLength={100}
                                    value={this.state.nombre}
                                    onChange={e => this.onChangeField('nombre', e.target.value)}
                                    error={() => this.getError('nombre')}
                                />
                                <ParadigmaLabeledInput
                                    disabled={vars.disabled}
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Nomenclatura"}
                                    maxLength={100}
                                    value={this.state.nomenclatura}
                                    onChange={e => this.onChangeField('nomenclatura', e.target.value)}
                                    error={() => this.getError('nomenclatura')}
                                />
                                <div className="ui-inline-actions">
                                    <label className={'ui-checkbox-field' + (vars.disabled ? ' is-disabled' : '')}>
                                        <span>En Dólares</span>
                                        <input
                                            type="checkbox"
                                            checked={enDolares}
                                            disabled={vars.disabled}
                                            onChange={e => this.onMonedaDolaresChange(e.target.checked)}
                                        />
                                    </label>
                                </div>
                                <div className="ui-inline-actions">
                                    <button type="button" className="ui-help-button ui-help-button-warning" id="infoMonedaLoteo" onClick={this.toggleMonedaPopover}>
                                        <i className="fa fa-question-circle"></i>
                                    </button>
                                    <Popover placement="bottom" isOpen={this.state.monedaPopoverOpen} target="infoMonedaLoteo" toggle={this.toggleMonedaPopover}>
                                        <PopoverHeader>Moneda del loteo</PopoverHeader>
                                        <PopoverBody>
                                            Si se selecciona el Loteo "En Dólares", todas las cuotas y recibos van a figurar en dólares. Caso contrario van a figurar en pesos. (Esta opcion no puede ser editada una vez creada el loteo, para cambiar la opción hay que eliminar el Loteo y crearlo nuevamente)
                                        </PopoverBody>
                                    </Popover>
                                </div>
                            </div>
                        </section>

                        <section className="ui-modal-section">
                                <p className="ui-section-label">Ubicación</p>
                                <div className="ui-form-grid">
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Dirección"}
                                        maxLength={200}
                                        value={this.state.direccion}
                                        onChange={e => this.onChangeField('direccion', e.target.value)}
                                        error={errors ? errors.direccion ? errors.direccion.direccion : null : null}
                                    />
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Número"}
                                        type="integer"
                                        value={this.state.numero}
                                        onChange={e => this.onChangeField('numero', e.target.value)}
                                        error={errors ? errors.direccion ? errors.direccion.numero : null : null}
                                    />
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Piso"}
                                        value={this.state.piso}
                                        onChange={e => this.onChangeField('piso', e.target.value)}
                                        error={() => this.getError('piso')}
                                    />
                                    <ParadigmaLabeledInput
                                        label="Provincia"
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                clearable={false}
                                                url={api.geograficas.provincias}
                                                parameters={{
                                                    paginationEnabled:false,
                                                    sort:['nombre']
                                                }}
                                                disabled={vars.disabled}
                                                value={this.state.provincia_id}
                                                onChange={data => this.setState({ provincia_id: data ? data.id : null, ciudad: null })}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        label="Ciudad"
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        error={errors ? errors.direccion ? errors.direccion.localidad_id : null : null}
                                        inputComponent={
                                            <ParadigmaAsyncSeeker
                                                clearable={false}
                                                url={provincia_id ? api.geograficas.localidades : ''}
                                                parameters={{
                                                    paginationEnabled:false,
                                                    sort:['nombre'],
                                                    concat:provincia_id ? `provincia=${provincia_id}` : ''
                                                }}
                                                disabled={!provincia_id || vars.disabled}
                                                value={this.state.ciudad}
                                                onChange={data => this.onChangeField('ciudad', (data)? data.id: null)}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Descripción"}
                                        value={this.state.descripcionDireccion}
                                        onChange={e => this.onChangeField('descripcionDireccion', e.target.value)}
                                        error={() => this.getError('descripcionDireccion')}
                                    />
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Latitud"}
                                        value={this.state.latitud}
                                        onChange={e => this.onChangeField('latitud', e.target.value)}
                                        error={() => this.getError('latitud')}
                                    />
                                    <ParadigmaLabeledInput
                                        disabled={vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Longitud"}
                                        value={this.state.longitud}
                                        onChange={e => this.onChangeField('longitud', e.target.value)}
                                        error={() => this.getError('longitud')}
                                    />
                                </div>
                                { (this.props.action === 'CREATE' || this.props.action === 'EDIT') ?
                                    <ModalMap onChange={this.onPositionChange} /> :
                                    this.state.activeTab === 1 && this.state.latitud && this.state.longitud &&
                                    <div className="ui-map-preview mt-3">
                                        <ParadigmaGoogleMap
                                            markers={[{ position: { lat: this.state.latitud, lng: this.state.longitud } }]}
                                            width="100%"
                                            height="170px"
                                            zoom={14}
                                            type="hybrid"
                                        />
                                    </div>
                                }
                            </section>

                        <section className="ui-modal-section">
                            <p className="ui-section-label">Descripción</p>
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12 ,12]}
                                classNames={fieldClassNames}
                                label={"Descripción"}
                                type="textarea"
                                value={this.state.descripcion}
                                onChange={e => this.onChangeField('descripcion', e.target.value)}
                                error={() => this.getError('descripcion')}
                            />
                        </section>
                    </TabPane>
                    <TabPane tabId={2}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Tipos de Unidades</p>
                            <div className="LoteosModalTipoUnidadesTable">
                                <ParadigmaTableModal
                                    title="Tipos de Unidades"
                                    disabled={vars.disabled}
                                    value={this.state.tiposDeUnidades}
                                    onChange={tiposDeUnidades => this.onChangeField('tiposDeUnidades', tiposDeUnidades)}
                                    error={() => this.getError('tiposDeUnidades')}
                                    columns={[
                                        {
                                            name: 'descripcion',
                                            label: 'Descripción',
                                            show: true,
                                            required: true,
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Descripción"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    maxLength={200}
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'superficie',
                                            label: 'Superficie',
                                            show: true,
                                            required: true,
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Superficie"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'cantidad',
                                            label: 'Cantidad',
                                            show: true,
                                            required: true,
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Cantidad"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    // type="number"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'frente',
                                            label: 'Frente',
                                            required: true,
                                            group: 'Medidas',
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Frente"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'contrafrente',
                                            label: 'Contrafrente',
                                            required: true,
                                            group: 'Medidas',
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Contrafrente"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'lado1',
                                            label: 'Lado A',
                                            required: true,
                                            group: 'Medidas',
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Lado A"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'lado2',
                                            label: 'Lado B',
                                            required: true,
                                            group: 'Medidas',
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Lado B"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'lado3',
                                            label: 'Lado C',
                                            required: false,
                                            group: 'Medidas',
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Lado C"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'lado4',
                                            label: 'Lado D',
                                            required: false,
                                            group: 'Medidas',
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Lado D"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'lado5',
                                            label: 'Lado E',
                                            required: false,
                                            group: 'Medidas',
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Lado E"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                        {
                                            name: 'lado6',
                                            label: 'Lado F',
                                            required: false,
                                            group: 'Medidas',
                                            Input: (value, onChange, disabled, error) => (
                                                <ParadigmaLabeledInput
                                                    label="Lado F"
                                                    md={[12, 12]}
                                                    classNames={fieldClassNames}
                                                    type="float"
                                                    value={value}
                                                    onChange={e => onChange(e.target.value)}
                                                    disabled={disabled}
                                                    error={error}
                                                />
                                            )
                                        },
                                    ]}
                                />
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    error={() => this.getError('tipoDeUnidad')}
                                    inputComponent={<Fragment></Fragment>}
                                />
                            </div>
                        </section>
                    </TabPane>

                    {
                        ['DELETE', 'DETAIL', 'LOTES'].includes(action) &&
                        <TabPane tabId={3}>
                            <section className="ui-modal-section">
                                <p className="ui-section-label">Lotes</p>
                                <TableLotes id={this.props.id} />
                            </section>
                        </TabPane>
                    }

                    <TabPane tabId={4}>
                        <div className="ui-section-grid">
                            <section className="ui-modal-section">
                                <div className="ui-section-label-row">
                                    <p className="ui-section-label">Plantillas de Venta</p>
                                    <button type="button" className="ui-help-button ui-help-button-warning" id="infoPlantillas" onClick={this.togglePopover}>
                                        <i className="fa fa-question-circle"></i>
                                    </button>
                                    <Popover placement="bottom" isOpen={this.state.popoverOpen} target="infoPlantillas" toggle={this.togglePopover}>
                                        <PopoverHeader>Información sobre Plantillas</PopoverHeader>
                                        <PopoverBody>
                                            Una plantilla es un archivo de extensión .docx que se reemplaza con la información de la venta.
                                            Las variables disponibles son: <br/>
                                            <strong>Datos del comprador</strong>
                                            <ul className="pl-3">
                                                <li>{'Nombre: {{nombreComprador}}'}</li>
                                                <li>{'Documento: {{dniComprador}}'}</li>
                                                <li>{'Domicilio:{{domicilioComprador}}'}</li>
                                            </ul>
                                            <strong>Datos del lote</strong>
                                            <ul className="pl-3">
                                                <li>{'Parcela: {{parcela}}'}</li>
                                                <li>{'Manzana: {{manzana}}'}</li>
                                                <li>{'Superficie: {{superficieUnidad}}'}</li>
                                            </ul>
                                            <strong>Datos de la compra</strong>
                                            <ul className="pl-3">
                                                <li>{'Día de la compra: {{diaFecha}}'}</li>
                                                <li>{'Mes de la compra: {{mesFecha}}'}</li>
                                                <li>{'Año de la compra: {{anioFecha}}'}</li>
                                                <li>{'Monto: {{montoUnidad}}'}</li>
                                                <li>{'Entrega inicial: {{entregaInicial}}'}</li>
                                                <li>{'Monto financiado: {{montoFinanciado}}'}</li>
                                                <li>{'Cuotas: {{cantidadCuotas}}'}</li>
                                                <li>{'Monto de las cuotas: {{montoCuota}}'}</li>
                                                <li>{'Día primer cuota: {{diaPrimeraCuota}}'}</li>
                                                <li>{'Mes primer cuota: {{mesPrimeraCuota}}'}</li>
                                                <li>{'Año primer cuota: {{anioPrimeraCuota}}'}</li>
                                                <li>{'Día última cuota: {{diaUltimaCuota}}'}</li>
                                                <li>{'Mes última cuota: {{mesUltimaCuota}}'}</li>
                                                <li>{'Año última cuota: {{anioUltimaCuota}}'}</li>
                                            </ul>
                                            <br/>
                                            <a href={api.resources.plantilla} target="_blank">Ver plantilla de ejemplo</a>
                                        </PopoverBody>
                                    </Popover>
                                </div>
                                <TableArchivos
                                    action={this.props.action}
                                    archivos={this.state.plantillas}
                                    onChange={data => this.onChangeField('plantillas', data)}
                                    url={api.loteos.plantilla.replace('$id_loteo', this.props.id())}
                                />
                            </section>

                            <section className="ui-modal-section">
                                <p className="ui-section-label">Documentos</p>
                                <TableArchivos
                                    action={this.props.action}
                                    archivos={this.state.documentos}
                                    onChange={data => this.onChangeField('documentos', data)}
                                    url={api.loteos.documento.replace('$id_loteo', this.props.id())}
                                />
                            </section>

                            <section className="ui-modal-section ui-span-2">
                                <p className="ui-section-label">Planos</p>
                                <TableArchivos
                                    action={this.props.action}
                                    archivos={this.state.planos}
                                    onChange={data => this.onChangeField('planos', data)}
                                    url={api.loteos.plano.replace('$id_loteo', this.props.id())}
                                />
                            </section>
                        </div>
                    </TabPane>
                    <TabPane tabId={5}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Datos Web</p>
                            <div className="ui-web-options-grid">
                                <div className="ui-web-option-row">
                                    <label className={'ui-checkbox-field' + (vars.disabled ? ' is-disabled' : '')}>
                                        <span>Mostrar en Web</span>
                                        <input
                                            type="checkbox"
                                            checked={this.state.mostrarEnWeb}
                                            disabled={vars.disabled}
                                            onChange={e => this.onChangeField('mostrarEnWeb', e.target.checked)}
                                        />
                                    </label>
                                </div>
                                <div className="ui-web-option-row">
                                    <label className={'ui-checkbox-field' + (vars.disabled ? ' is-disabled' : '')}>
                                        <span>Destacado</span>
                                        <input
                                            type="checkbox"
                                            checked={this.state.destacado}
                                            disabled={vars.disabled}
                                            onChange={e => this.onChangeField('destacado', e.target.checked)}
                                        />
                                    </label>
                                </div>
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Categoría"}
                                    error={() => this.getError('tipo_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            url={api.loteos.tipoloteos}
                                            disabled={!this.state.mostrarEnWeb || vars.disabled}
                                            value={this.state.tipo_id}
                                            onChange={data => this.onChangeField('tipo_id', data ? data.id : null)}
                                        />
                                    }
                                />
                                <ParadigmaLabeledInput
                                    disabled={!this.state.mostrarEnWeb || vars.disabled}
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Anticipo"}
                                    type="float"
                                    value={this.state.anticipo}
                                    onChange={e => this.onChangeField('anticipo', e.target.value)}
                                    error={() => this.getError('anticipo')}
                                />
                                <div className="ui-form-grid-complete">
                                    <ParadigmaLabeledInput
                                        disabled={!this.state.mostrarEnWeb || vars.disabled}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        label={"Cuotas"}
                                        maxLength={3}
                                        type="integer"
                                        value={this.state.cuotas}
                                        onChange={e => this.onChangeField('cuotas', e.target.value)}
                                        error={() => this.getError('cuotas')}
                                    />
                                </div>
                            </div>
                        </section>

                        <section className="ui-modal-section">
                            <p className="ui-section-label">Imágenes</p>
                            <UploadImages
                                disabled={vars.disabled}
                                imagenes={this.state.imagenes}
                                onChange={imagenes => this.setState({ imagenes })}
                            />
                        </section>

                        <section className="ui-modal-section">
                            <p className="ui-section-label">Descripción Web</p>
                            <ModalRichTextEditor
                                value={this.state.descripcionWeb}
                                onSubmit={descripcionWeb => this.setState({ descripcionWeb })}
                                disabled={this.props.action === 'DELETE' || this.props.action === 'DETAIL'}
                            />
                        </section>
                    </TabPane>
                </TabContent>

            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Loteos/Modal.js